import { fetchAuthSession, fetchUserAttributes, getCurrentUser, signIn, signOut } from 'aws-amplify/auth';
import awsconfig from '../aws-exports';

class User {
  login = async (email, password) => {
    try {
      const result = await signIn({
        username: this.idAddDomain(email),
        password,
      });
      if (result?.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      }
      return true;
    } catch (error) {
      // 既にサインイン済みの場合は成功扱いにする
      if (error.name === 'UserAlreadyAuthenticatedException') {
        return true;
      }
      return false;
    }
  };

  logout = async () => {
    await signOut();
  };

  accessToken = async () => {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken;

    if (!token) return null;
    if (typeof token === 'string') return token;
    if (typeof token.toString === 'function') return token.toString();
    if (token.jwtToken) return token.jwtToken;

    return null;
  };

  fetchAttributes = async () => {
    try {
      await getCurrentUser();
      const attrs = await fetchUserAttributes();
      return attrs ?? null;
    } catch {
      return null;
    }
  };

  fetchUserData = async () => {
    const attrs = await this.fetchAttributes();
    if (!attrs) return null;

    const displayName =
      attrs.name || attrs.preferred_username || attrs.given_name || attrs.family_name || attrs.email || '';

    return {
      ...attrs,
      name: displayName,
    };
  };

  isEmailLoginFromUserData = (userData) => {
    const domain = process.env.REACT_APP_LOGIN_ADDDOMAIN ?? '';
    const email = userData?.email ?? '';

    if (!domain || !email) return false;
    return email.lastIndexOf(domain) === -1;
  };

  userData = () => {
    const key = [];
    key.push('CognitoIdentityServiceProvider');
    key.push(awsconfig.aws_user_pools_web_client_id);
    const lastAuthUser = localStorage.getItem(key.join('.') + '.LastAuthUser');
    if (!lastAuthUser) {
      return false;
    }
    key.push(lastAuthUser);
    key.push('userData');
    const raw = localStorage.getItem(key.join('.'));
    if (!raw) {
      return false;
    }

    let json;
    try {
      json = JSON.parse(raw);
    } catch {
      return false;
    }

    if (!json?.UserAttributes) {
      return false;
    }
    const data = [];
    for (let i in json.UserAttributes) {
      data[json.UserAttributes[i]['Name']] = json.UserAttributes[i]['Value'];
    }
    return data;
  };
  idAddDomain = (email) => {
    if (email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
      return email;
    }
    return email + process.env.REACT_APP_LOGIN_ADDDOMAIN;
  };
  isEmailLogin = () => {
    let user = this.userData();
    if (user && user.email.lastIndexOf(process.env.REACT_APP_LOGIN_ADDDOMAIN) === -1) {
      return true;
    }
    return false;
  };
}

const user = new User();
export default user;
